import * as types from '../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const GetMyMetricsListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_MY_METRICS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_MY_METRICS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.GET_MY_METRICS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.RESET_MY_METRICS_LIST_DATA: // Add this case to handle reset
      return {
        ...state,
        user: [], // Reset the user data to its initial state
        error: null, // Optionally, you can reset the error state as well
      };
    default:
      return state;
  }
};

export default GetMyMetricsListReducer;
